<template>
  <div>
    <v-flex xs12 sm12 md12>
      <Filters />
    </v-flex>
    <v-flex xs12 sm12 md12 class="align-content-end">
      <SalesTotals />
    </v-flex>
    <v-flex xs12 sm12 md12 class="align-content-end">
      <SalesList />
    </v-flex>
  </div>
</template>
<script>
import Filters from "../../components/sales/Filters";
import SalesList from "../../components/sales/SalesList";
import SalesTotals from "../../components/sales/SalesTotals";
export default {
  components: {
    Filters,
    SalesList,
    SalesTotals,
  },
};
</script>
